module.exports = __webpack_public_path__ + "static/media/sign-in-asset2.8e74d832.svg";